/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BaseIntegrationData
 */
export interface BaseIntegrationData {
    /**
     * 
     * @type {string}
     * @memberof BaseIntegrationData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseIntegrationData
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseIntegrationData
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseIntegrationData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseIntegrationData
     */
    project?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseIntegrationData
     */
    errors?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BaseIntegrationData
     */
    authorizationSuccessful?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseIntegrationData
     */
    lastRegularUpdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BaseIntegrationData
     */
    lastHistoricalUpdate?: string | null;
}

/**
 * Check if a given object implements the BaseIntegrationData interface.
 */
export function instanceOfBaseIntegrationData(value: object): value is BaseIntegrationData {
    return true;
}

export function BaseIntegrationDataFromJSON(json: any): BaseIntegrationData {
    return BaseIntegrationDataFromJSONTyped(json, false);
}

export function BaseIntegrationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseIntegrationData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'name': json['name'] == null ? undefined : json['name'],
        'project': json['project'] == null ? undefined : json['project'],
        'errors': json['errors'] == null ? undefined : json['errors'],
        'authorizationSuccessful': json['authorizationSuccessful'] == null ? undefined : json['authorizationSuccessful'],
        'lastRegularUpdate': json['lastRegularUpdate'] == null ? undefined : json['lastRegularUpdate'],
        'lastHistoricalUpdate': json['lastHistoricalUpdate'] == null ? undefined : json['lastHistoricalUpdate'],
    };
}

export function BaseIntegrationDataToJSON(json: any): BaseIntegrationData {
    return BaseIntegrationDataToJSONTyped(json, false);
}

export function BaseIntegrationDataToJSONTyped(value?: BaseIntegrationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'created': value['created'],
        'updated': value['updated'],
        'name': value['name'],
        'project': value['project'],
        'errors': value['errors'],
        'authorizationSuccessful': value['authorizationSuccessful'],
        'lastRegularUpdate': value['lastRegularUpdate'],
        'lastHistoricalUpdate': value['lastHistoricalUpdate'],
    };
}

